import { SearchCriteria } from "./search-criteria";

export class GetClientBookingsSearchCriteria extends SearchCriteria {

}
